import { createSlice } from '@reduxjs/toolkit';

import type { AccessRightsModuleDto } from '@app/services/rtkQuery/types';
import { accessRightsInitialState as initialState } from '@app/store/slices/AccessRights/constants';
import type { UserAccessRightsInterface } from '@app/types/NewAccessRight';

import type { PayloadAction } from '@reduxjs/toolkit';

const accessRightsSlice = createSlice({
  name: 'accessRights',
  initialState,
  reducers: {
    setAccessRights: (
      state,
      action: PayloadAction<UserAccessRightsInterface>
    ) => ({
      ...state,
      user: { ...state.user, ...action.payload },
    }),
    setOrgModulesAccessRights: (
      state,
      action: PayloadAction<AccessRightsModuleDto[]>
    ) => ({
      ...state,
      organization: action.payload,
    }),
    setLoading: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isLoading: action.payload,
    }),
  },
});

const { actions, reducer } = accessRightsSlice;

export const { setAccessRights, setOrgModulesAccessRights, setLoading } =
  actions;

export const accessRightsReducer = reducer;
